/* Zohar variant pills (draft 19.10). Vanilla, no dependencies. Markup: snippets/zohar-variant-pills.liquid */
(function () {
  'use strict';
  function init(root) {
    if (root.__zvp) return;
    root.__zvp = true;
    var json = root.querySelector('[data-zohar-vp-json]');
    if (!json) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (e) { return; }
    var form = null;
    var sib = root.nextElementSibling;
    while (sib && !form) {
      if (sib.matches && sib.matches('form[action*="/cart/add"]')) form = sib;
      else if (sib.querySelector) form = sib.querySelector('form[action*="/cart/add"]');
      sib = sib.nextElementSibling;
    }
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('button[name="add"], [type="submit"]');
    var body = root.closest('.zohar-pdp__body') || document;
    var price = body.querySelector('p.price');
    var article = root.closest('.zohar-pdp') || document;
    var gallery = article.querySelector('.zohar-pdp__gallery');

    function selected() {
      var opts = [];
      root.querySelectorAll('[data-zohar-vp-option]').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        opts[parseInt(fs.getAttribute('data-zohar-vp-option'), 10) - 1] = c ? c.value : null;
      });
      root.querySelectorAll('[data-zohar-vp-fixed]').forEach(function (h) {
        opts[parseInt(h.getAttribute('data-zohar-vp-fixed'), 10) - 1] = h.value;
      });
      return opts;
    }
    function find(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var k = 0; k < opts.length; k++) { if (v.options[k] !== opts[k]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function markAvailability(opts) {
      root.querySelectorAll('[data-zohar-vp-option]').forEach(function (fs) {
        var pos = parseInt(fs.getAttribute('data-zohar-vp-option'), 10) - 1;
        fs.querySelectorAll('input').forEach(function (inp) {
          var probe = opts.slice(); probe[pos] = inp.value;
          var v = find(probe);
          var lbl = root.querySelector('label[for="' + inp.id + '"]');
          if (lbl) lbl.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function showMedia(v) {
      if (!gallery || !v || !v.media_position) return;
      var thumb = gallery.querySelector('[data-zg-thumb="' + (v.media_position - 1) + '"]');
      if (thumb) { thumb.click(); return; }
      var img = gallery.querySelector('img');
      if (img && v.media_src) { img.removeAttribute('srcset'); img.src = v.media_src; }
    }
    function apply(pushUrl) {
      var opts = selected();
      var v = find(opts);
      markAvailability(opts);
      if (!v) { if (addBtn) addBtn.disabled = true; return; }
      if (idInput) idInput.value = v.id;
      if (addBtn) addBtn.disabled = !v.available;
      if (price && v.price) price.textContent = v.price;
      if (pushUrl) {
        showMedia(v);
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        } catch (e) {}
      }
    }
    root.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('zohar-vp__input')) apply(true);
    });
    apply(false);
  }
  function boot() { document.querySelectorAll('[data-zohar-vp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
